import type { VerificationResultDto } from './dto';
import type { VerificationResult } from './types';

export const mapVerificationResultDtoToModel = (
  result: VerificationResultDto,
): VerificationResult => {
  const status = result?.results[0]?.status || result.status;
  return { status };
};
